import { NgRedux } from '@redux/redux-compatibility.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { IgnoredWord } from 'src/app/shared/models/common';
import { AppState } from 'src/app/shared/redux/store';

@Component({
    selector: 'add-spelling-check-ignored',
    templateUrl: './add-spelling-check-ignored.component.html',
    styleUrls: ['./add-spelling-check-ignored.component.scss'],
    standalone: false
})
export class AddSpellingCheckIgnoredComponent implements OnInit {

  @Output() onAdd = new EventEmitter<IgnoredWord>();
  @Output() onClose = new EventEmitter();
  spellingCheckIgnoredWord: string;
  useGlobally: boolean;

  ngOnInit(): void {}

  add() {
    const ignoredWord = new IgnoredWord(
      undefined,
      this.spellingCheckIgnoredWord,
      this.useGlobally
    );
    
    this.onAdd.emit(ignoredWord);
  }

  close() {
    this.onClose.emit();
  }

}
